(function() {
  const originalFetch = window.fetch;
  window.fetch = function(url, options) {
    if (url.includes('/cart/change.js')) {
      try {
        const data = JSON.parse(options.body);
        data.id = data?.id?.split(":")?.[0];
        options.body = JSON.stringify(data);
      } catch (e) {
        console.error('Could not patch cart request', e);
      }
    }
    return originalFetch.apply(this, arguments);
  };  
})();


document.addEventListener("DOMContentLoaded", function () {
  // Check if we are on the specific page by URL
  if (window.location.pathname === "/pages/foam-box-scanning") {
    const btn = document.getElementById('update-additional-info-btn');
    if (btn) {
      btn.click();
    }
  }
});

